export const getUniqKeys = (arr: any[]): string[] => {
  return Object.keys(Object.assign({}, ...arr));
};
